<template>
  <div class="legend_wraper" v-show="isShowLegend">
    <div
      :style="{ display: item.type == '机柜点位' ? 'none' : 'flex' }"
      class="legend_list"
      v-for="(item, index) of legends"
      :key="index"
      :class="item.highlight ? 'top_text_ac' : ''"
    >
      <!-- :class="item.highlight ? 'top_text_ac' : ''" -->
      <div class="top_text" @click="showOption(index)">
        <div>
          <img
            ondragstart="return false;"
            v-if="item.highlight"
            :src="item.img + 'ac.png'"
            alt
          />
          <img
            ondragstart="return false;"
            v-else
            :src="item.img + '.png'"
            alt
          />
        </div>
        <div class="group_txt">{{ item.type }}</div>
        <div>
          <img
            v-if="optionIndex == index"
            ondragstart="return false;"
            :src="'/img/legend/arrows_up.png'"
            alt
          />
          <img
            v-else
            ondragstart="return false;"
            :src="'/img/legend/arrows_down.png'"
            alt
          />
        </div>
      </div>
      <div class="item_cont" v-if="optionIndex == index">
        <div
          class="item"
          v-for="(ele, sub) in item.children"
          @click.prevent="legendClick(ele, item)"
          :key="sub"
          :class="ele.highlight ? 'item_ac' : ''"
        >
          <div class="item_img">
            <img
              ondragstart="return false;"
              v-if="ele.highlight"
              :src="ele.img + 'ac.png'"
              alt
            />
            <img
              ondragstart="return false;"
              v-else
              :src="ele.img + '.png'"
              alt
            />

            <!-- <img ondragstart="return false;" :src="ele.img + 'ac.png'" alt /> -->
          </div>
          <div class="item_text">{{ ele.showText }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'legend_wraper',
  props: {
    legends: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      optionIndex: -1, // 打开图例组
      isShowLegend: true, // 是否显示图例组件
    }
  },
  methods: {
    changeSelected() {},
    showOption(index) {
      if (index == this.optionIndex) {
        this.optionIndex = -1
      } else {
        this.optionIndex = index
      }
    },
    legendClick(ele, group) {
      console.log(ele)
      ele.highlight = !ele.highlight
      // 容量互斥逻辑
      if (['空间使用', '功耗使用', '承重使用'].includes(ele.showText)) {
        if (ele.highlight) {
          group.children.forEach((legend) => {
            if (legend.showText != ele.showText && legend.highlight) {
              legend.highlight = false
              this.$emit('legendClick', legend)
            }
          })
        }
      }
      this.$emit('legendClick', ele)
      this.$store.commit('setLegendTextInfo', ele)
      if (ele.highlight) {
        group.highlight = true
      } else {
        group.highlight = false
        group.children.filter((i) => {
          if (i.highlight) {
            group.highlight = true
          }
        })
      }
    },
    /**
     * @description:
     * @param {*} legend 图例模块名称
     * @param {*} children 子图例名称
     * @return {*}
     */

    highLight(legend, children) {
      const currentLegend = this.legends.find((item) => item.type == legend)
      children.forEach((cname) => {
        currentLegend.children.forEach((item) => {
          if (cname == item.txt) {
            item.highlight = true
          }
        })
      })
    },
  },
  created() {},
  computed: {
    ...mapState(['selectLegends', 'functionStatus', 'spaceLevel']),
  },
  watch: {
    $route: {
      handler: function (to, from) {
        this.optionIndex = -1
      },
      deep: true,
    },
    functionStatus: {
      handler: function (to, from) {
        this.optionIndex = -1
        if (to == '对象管理' || to == '实时告警' || to == '高级搜索') {
          this.isShowLegend = false
        } else {
          this.isShowLegend = true
        }
      },
      deep: true,
    },
    spaceLevel: {
      handler: function (to, from) {
        this.optionIndex = -1
        this.$store.commit('setLegendTextInfo', '')
      },
      deep: true,
    },
    // highLight: {
    //   handler(val) {
    //   },
    //   deep: true,
    // },
  },
  mounted() {},
}
</script>

<style lang="less" scoped>
.none {
  display: none;
}
.legend_wraper {
  display: flex;
  align-items: center;
  .legend_list {
    min-width: 220px;
    height: 60px;
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 5px;
    box-sizing: border-box;
    margin-left: 10px;
    line-height: 60px;
    display: flex;
    position: relative;
    background: linear-gradient(
        to bottom,
        rgba(255, 255, 255, 0.1) 0,
        rgba(255, 255, 255, 0.1) 100%
      ),
      linear-gradient(
        to bottom,
        rgba(14, 34, 52, 0.85) 0,
        rgba(14, 34, 52, 0) 100%
      );

    .top_text {
      width: 100%;
      display: flex;
      justify-content: space-around;
      align-items: center;
      font-family: '微软雅黑';
      font-size: 28px;
      background-image: linear-gradient(
        to bottom,
        rgba(255, 255, 255, 0.85) 30%,
        rgba(191, 255, 255, 0.85)
      );
      background-clip: text;
      -webkit-background-clip: text;
      color: transparent;
      .group_txt {
        white-space: nowrap;
      }
      div {
        display: flex;
        align-items: center;
      }
    }
    img {
      vertical-align: middle;
    }
    .item_cont {
      position: absolute;
      bottom: 63px;
      font-family: '微软雅黑';
      font-size: 28px;
      min-width: 220px;
      // max-width: 150px;
      // width: 100%;
      .item {
        display: flex;
        align-items: center;
        height: 60x;
        padding: 0 10px;
        border: 1px solid rgb(71, 95, 112);
        box-sizing: border-box;
        margin-bottom: 1px;
        line-height: 60px;
        background: rgba(13, 32, 51, 0.75);
        color: #aaaaaa;

        .item_img {
          display: flex;
          justify-content: center;
          align-items: center;
          text-align: center;
          margin-right: 10px;
          width: 24px;
          height: 24px;
        }
        .item_text {
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .item:not(:first-child) {
        margin-top: -1px;
      }
      .item.item_ac {
        z-index: 1;
        border: 1px solid rgba(255, 255, 255, 0.5);
        color: #ffffff;
        background: rgba(92, 170, 248, 0.6);
        margin-top: -1px;
      }
    }
  }
  .legend_list.top_text_ac {
    border: 1px solid rgba(114, 162, 226, 0.8);
    // background: linear-gradient(
    //     to bottom,
    //     rgba(255, 255, 255, 0.1) 0,
    //     rgba(255, 255, 255, 0.1) 100%
    //   ),
    //   linear-gradient(
    //     to bottom,
    //     rgba(14, 34, 52, 0.75) 0,
    //     rgba(14, 34, 52, 0) 100%
    //   );
    background: rgba(0, 38, 77, 0.75);
    .top_text {
      background-image: none;
      color: #5aaaf8;
      text-shadow: 0 0 10px #5aaaf8;
      div {
        display: flex;
        align-items: center;
      }
    }
  }
}
</style>
